module.exports = __webpack_public_path__ + "img/base_activites_montagnes_russes.801ee7d6.svg";